/* 무료보험 프로모션 추가부분 */
import React from 'react'

import MyhouseInsuranceDetail from '@Components/templates/MyhouseInsuranceDetail'

function InsuranceClaimPage() {
  return (
    <>
      <MyhouseInsuranceDetail />
    </>
  )
}

export default InsuranceClaimPage
